import { render, staticRenderFns } from "./reply-to-customer-dialog.vue?vue&type=template&id=05d8e88d&scoped=true&"
import script from "./reply-to-customer-dialog.vue?vue&type=script&lang=js&"
export * from "./reply-to-customer-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d8e88d",
  null
  
)

export default component.exports